import React from 'react';
import { Outlet } from 'react-router-dom';
export const FullPageLayout = () => {
  return /*#__PURE__*/React.createElement(Outlet, null);
};